import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';

import carsBatch from './batches';
import filters from './filters';
import closedBatches from './closedBatches';
import auctions from './auctions';
import rentingRedRac from './rentingRedRac';

const carsBatchConfig = {
    key: 'carsBatch',
    storage,
    blacklist: ['error'],
};

const filtersConfig = {
    key: 'filters',
    storage: storageSession,
    blacklist: ['base'], //persist initial on refresh?
};

const closedBatchesConfig = {
    key: 'closedBatches',
    storage: storageSession,
    blacklist: [],
};

export default combineReducers({
    carsBatch: persistReducer(carsBatchConfig, carsBatch),
    filters: persistReducer(filtersConfig, filters),
    closedBatches: persistReducer(closedBatchesConfig, closedBatches),
    auctions,
    rentingRedRac,
});
